const hasValue = (value) => {
    return value || value === 0 || value === '0' || value === false
}


export { hasValue }
